import { render, staticRenderFns } from "./franchise.vue?vue&type=template&id=8697cae2&"
import script from "./franchise.vue?vue&type=script&lang=js&"
export * from "./franchise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports